var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress",class:[_vm.value === null ? 'indeterminate' : 'determinate']},[_c('span',{staticClass:"progress-inner",style:({
      width: _vm.value ? (((_vm.value / _vm.max) * 100) + "%") : null
    })})])}
var staticRenderFns = []

export { render, staticRenderFns }